import React, { Component } from 'react';
import { Input, Col, Row, Select } from 'antd';
import debounce from 'lodash/debounce';
import { STATUS } from '../../../../redux/constants';
import styles from './organization-profile.module.sass';
import CountrySelect from '../../../../shared-components/CountrySelect';
import VersionCheck from '../../../../shared-components/VersionCheck';

const getOrganizationFields = (organization) => {
  return {
    top_brand: organization?.top_brand,
    company_domain: organization?.company_domain,
    company_name: organization?.company_name,
    city: organization?.city,
    address: organization?.address,
    phone: organization?.phone,
    country: organization?.country,
  };
};

export class OrganizationProfile extends Component {
  static getDerivedStateFromProps(props, state) {
    const { organization } = props;

    if (props.status !== state.status && props.status === STATUS.LOADED) {
      return {
        status: props.status,
        ...getOrganizationFields(organization),
      };
    }
    return {
      status: props.status,
    };
  }

  state = {
    status: STATUS.IDLE,
  };

  componentDidMount() {
    this.props.loadOrganization();
  }

  handlePropChange = (value, propName) => {
    this.setState({ [propName]: value }, () => {
      this.handleOrganizationUpdate();
    });
  };

  handleSubmit = () => {
    const {
      top_brand,
      company_domain,
      company_name,
      city,
      address,
      phone,
      country,
      email,
    } = this.state;

    this.props.updateOrganization({
      top_brand,
      company_domain,
      company_name,
      city,
      address,
      phone,
      country,
      email,
    });
  };

  handleOrganizationUpdate = debounce(
    () => {
      this.handleSubmit();
    },
    700,
    {
      leading: false,
      trailing: true,
    },
  );

  render() {
    const { departments } = this.props;
    const { company_name, city, address, phone, country, email } = this.state;
    return (
      <Row>
        <Col span={16} className={styles.p_r}>
          <div className={styles.section_header}>Organization Information</div>
          <Row>
            <Col span={24}>
              <div className={styles.form_control}>
                <label className={styles.label}>Organization:</label>
                <Input
                  disabled={
                    this.props?.user?.is_organization_admin === true
                      ? false
                      : true
                  }
                  data-testid={'input1001'}
                  className={styles.input}
                  value={company_name}
                  onChange={(e) =>
                    this.handlePropChange(e.target.value, 'company_name')
                  }
                />
              </div>
            </Col>
          </Row>
          <Row>
            <Col span={12} className={styles.p_r}>
              <div className={styles.form_control}>
                <label className={styles.label}>Country:</label>
                <CountrySelect
                  onChange={(value) => {
                    this.handlePropChange(value, 'country');
                  }}
                  disabled={
                    this.props?.user?.is_organization_admin === true
                      ? false
                      : true
                  }
                  value={country}
                  mode="single"
                  style={{ textAlign: 'left' }}
                />
              </div>
            </Col>
            <Col span={12} className={styles.p_l}>
              <div className={styles.form_control}>
                <label className={styles.label}>City:</label>
                <Input
                  disabled={
                    this.props?.user?.is_organization_admin === true
                      ? false
                      : true
                  }
                  data-testid={'input1002'}
                  className={styles.input}
                  value={city}
                  onChange={(e) =>
                    this.handlePropChange(e.target.value, 'city')
                  }
                />
              </div>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <div className={styles.form_control}>
                <label className={styles.label}>Address:</label>
                <Input
                  disabled={
                    this.props?.user?.is_organization_admin === true
                      ? false
                      : true
                  }
                  data-testid={'input1003'}
                  className={styles.input}
                  value={address}
                  onChange={(e) =>
                    this.handlePropChange(e.target.value, 'address')
                  }
                />
              </div>
            </Col>
          </Row>
          <Row>
            <Col span={12} className={styles.p_r}>
              <div className={styles.form_control}>
                <label className={styles.label}>E-mail:</label>
                <Input
                  disabled={
                    this.props?.user?.is_organization_admin === true
                      ? false
                      : true
                  }
                  data-testid={'input1004'}
                  className={styles.input}
                  value={email}
                  onChange={(e) =>
                    this.handlePropChange(e.target.value, 'email')
                  }
                />
              </div>
            </Col>
            <Col span={12} className={styles.p_l}>
              <div className={styles.form_control}>
                <label className={styles.label}>Phone number:</label>
                <Input
                  disabled={
                    this.props?.user?.is_organization_admin === true
                      ? false
                      : true
                  }
                  data-testid={'input1005'}
                  className={styles.input}
                  value={phone}
                  onChange={(e) =>
                    this.handlePropChange(e.target.value, 'phone')
                  }
                />
              </div>
            </Col>
          </Row>
        </Col>
        {/* <Col span={8} className={styles.p_l}>
          <div className={styles.section_header}>
            Organization's Contact Information
          </div>

          <div className={styles.form_control}>
            <label className={styles.label}>First and Last name:</label>
            <Input
            disabled={this.props?.user?.is_organization_admin === true ? false : true}
              className={styles.input}
              // value={company_name}
              // onChange={(e) => this.handlePropChange(e.target.value, 'company_name')}
            />
          </div>

          <div className={styles.form_control}>
            <label className={styles.label}>Department:</label>
            <Select className={styles.input} disabled={this.props?.user?.is_organization_admin === true ? false : true} options={departments} />
          </div>

          <div className={styles.form_control}>
            <label className={styles.label}>Address:</label>
            <Input
            disabled={this.props?.user?.is_organization_admin === true ? false : true}
              className={styles.input}
              // value={company_name}
              // onChange={(e) => this.handlePropChange(e.target.value, 'company_name')}
            />
          </div>

          <div className={styles.form_control}>
            <label className={styles.label}>City:</label>
            <Input
            disabled={this.props?.user?.is_organization_admin === true ? false : true}
              className={styles.input}
              // value={company_name}
              // onChange={(e) => this.handlePropChange(e.target.value, 'company_name')}
            />
          </div>

          <div className={styles.form_control}>
            <label className={styles.label}>Country:</label>
            <Input
              className={styles.input}
              disabled={this.props?.user?.is_organization_admin === true ? false : true}
              // value={company_name}
              // onChange={(e) => this.handlePropChange(e.target.value, 'company_name')}
            />
          </div>

          <div className={styles.form_control}>
            <label className={styles.label}>E-mail:</label>
            <Input
            disabled={this.props?.user?.is_organization_admin === true ? false : true}
              className={styles.input}
              // value={company_name}
              // onChange={(e) => this.handlePropChange(e.target.value, 'company_name')}
            />
          </div>

          <div className={styles.form_control}>
            <label className={styles.label}>Phone number:</label>
            <Input
            disabled={this.props?.user?.is_organization_admin === true ? false : true}
              className={styles.input}
              // value={company_name}
              // onChange={(e) => this.handlePropChange(e.target.value, 'company_name')}
            />
          </div>
        </Col> */}
        <VersionCheck parentComponentStatus={this.props.status} />
      </Row>
    );
  }
}

export default OrganizationProfile;
